import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { api_constants } from '../../constants/api-constants';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss']
})
export class CreateCategoryComponent {

  private unsubscribe = new Subject<void>();
  activity_form: any = FormGroup;
  button_loader: boolean = false;
  submited: boolean = false;
  activity_id: string = '';
  activity_type: any;

  constructor(
    public dialogRef: MatDialogRef<CreateCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: ApiService,
    private toast: ToastrService,
    private _form_builder: FormBuilder
  ) {
    this.activity_id = data?._id;
    this.activity_type = data?.type
    this.activity_form = this._form_builder.group({
      name: ['', Validators.required],
    });
    this.activity_form.patchValue({
      name: data?.name,
    });

    if (this.activity_id && this.activity_type == 'bingo') {
      this.getBingoCategoryDetail(this.activity_id);
    } else if (this.activity_id && this.activity_type == 'fun') {
      this.getFunCategoryDetail(this.activity_id);
    } else if (this.activity_id && this.activity_type == 'offer') {
      this.getOfferCategoryDetail(this.activity_id);
    } else if (this.activity_id && this.activity_type == 'guide/event') {
      this.getGuideEventCategoryDetail(this.activity_id);
    }
  }

  ngOnInit(): void { }

  get f() {
    return this.activity_form.controls;
  }

  closeModal(status: boolean) {
    this.dialogRef.close(status);
  }

  close() {
    this.dialogRef.close();
  }

  getBingoCategoryDetail(id: any) {
    let $this = this;
    this.api
      .ExecuteGet(
        `${this.api?.baseUrl + api_constants?.update_bingo_category}/${id}`
      )
      .subscribe({
        next(value: any) {
          $this.activity_form?.patchValue({
            name: value?.name,
          });
        },
        error(err) {
          console.log('Error', err);
        },
      });
  }

  getFunCategoryDetail(id: any) {
    let $this = this;
    this.api
      .ExecuteGet(
        `${this.api?.baseUrl + api_constants?.fun_activity_category}/${id}`
      )
      .subscribe({
        next(value: any) {
          $this.activity_form?.patchValue({
            name: value?.name,
          });
        },
        error(err) {
          console.log('Error', err);
        },
      });
  }

  getOfferCategoryDetail(id: any) {
    let $this = this;
    this.api
      .ExecuteGet(
        `${this.api?.baseUrl + api_constants?.offer_category_detail}/${id}`
      )
      .subscribe({
        next(value: any) {
          $this.activity_form?.patchValue({
            name: value?.name,
          });
        },
        error(err) {
          console.log('Error', err);
        },
      });
  }

  getGuideEventCategoryDetail(id: any) {
    let $this = this;
    this.api
      .ExecuteGet(
        `${this.api?.baseUrl + api_constants?.guide_event_category}/${id}`
      )
      .subscribe({
        next(value: any) {
          $this.activity_form?.patchValue({
            name: value?.name,
          });
        },
        error(err) {
          console.log('Error', err);
        },
      });
  }

  submit(data: any) {

    if (this.activity_form.invalid) {
      this.toast.warning(`Please fill in the required feild`, 'Warning', {
        closeButton: true,
      });
    } else {

      if (this.activity_id && this.activity_type == 'bingo') {
        this.updateBingoCategoryApi(data);
      } else if (this.activity_id && this.activity_type == 'fun') {
        this.updateFunCategoryApi(data);
      } else if (this.activity_id && this.activity_type == 'offer') {
        this.updateOfferCategoryApi(data);
      } else if (this.activity_id && this.activity_type == 'guide/event') {
        this.updateGuideEventCategoryApi(data);
      } else if (!this.activity_id && this.activity_type == 'bingo') {
        this.createBingoCategoryApi(data);
      } else if (!this.activity_id && this.activity_type == 'fun') {
        this.createFunCategoryApi(data);
      } else if (!this.activity_id && this.activity_type == 'offer') {
        this.createOfferCategoryApi(data);
      } else if (!this.activity_id && this.activity_type == 'guide/event') {
        this.createGuideEventCategoryApi(data);
      }
    }

  }

  createFunCategoryApi(data: any) {
    let $this = this;
    this.api
      .ExecutePost(
        `${this.api?.baseUrl + api_constants.fun_activity_category}`,
        data
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(`Activity Created Successfully`, 'Success', {
            closeButton: true,
          });
         $this.closeModal(true);

        },
        error(err) {
          console.log('error:', err);
          $this.toast.error(`Activity Creation Failed,Try again later`, 'Error', {
            closeButton: true,
          });
        },
      });
  }

  createBingoCategoryApi(data: any) {
    let $this = this;
    this.api
      .ExecutePost(
        `${this.api?.baseUrl + api_constants.update_bingo_category}`,
        data
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(`Activity Created Successfully`, 'Success', {
            closeButton: true,
          });
          $this.closeModal(true);
        },
        error(err) {
          console.log('error:', err);
          $this.toast.error(`Activity Creation Failed,Try again later`, 'Error', {
            closeButton: true,
          });
        },
      });
  }

  createOfferCategoryApi(data: any) {
    let $this = this;
    this.api
      .ExecutePost(
        `${this.api?.baseUrl + api_constants.offer_category_add}`,
        data
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(`Activity Created Successfully`, 'Success', {
            closeButton: true,
          });
          $this.closeModal(true);
        },
        error(err) {
          console.log('error:', err);
          $this.toast.error(`Activity Creation Failed,Try again later`, 'Error', {
            closeButton: true,
          });
        },
      });
  }

  createGuideEventCategoryApi(data: any) {
    let $this = this;
    this.api
      .ExecutePost(
        `${this.api?.baseUrl + api_constants.guide_event_category}`,
        data
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(`Activity Created Successfully`, 'Success', {
            closeButton: true,
          });
          $this.closeModal(true);
        },
        error(err) {
          console.log('error:', err);
          $this.toast.error(`Activity Creation Failed,Try again later`, 'Error', {
            closeButton: true,
          });
        },
      });
  }

  updateFunCategoryApi(data: any) {
    let $this = this;
    this.api
      .ExecutePut(
        `${this.api?.baseUrl + api_constants.fun_activity_category}/${this.activity_id
        }`,
        data
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(`Activity Updated Successfully`, 'Success', {
            closeButton: true,
          });
          $this.closeModal(true);
        },
        error(err) {
          console.log('error:', err);
          $this.toast.error(`Activity Updation Failed,Try again later`, 'Error', {
            closeButton: true,
          });
        },
      });
  }

  updateBingoCategoryApi(data: any) {
    let $this = this;
    this.api
      .ExecutePut(
        `${this.api?.baseUrl + api_constants.update_bingo_category}/${this.activity_id
        }`,
        data
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(`Activity Updated Successfully`, 'Success', {
            closeButton: true,
          });
          $this.closeModal(true);
        },
        error(err) {
          console.log('error:', err);
          $this.toast.error(`Activity Updation Failed,Try again later`, 'Error', {
            closeButton: true,
          });
        },
      });
  }

  updateOfferCategoryApi(data: any) {
    let $this = this;
    this.api
      .ExecutePut(
        `${this.api?.baseUrl + api_constants.offer_category_update}/${this.activity_id
        }`,
        data
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(`Activity Updated Successfully`, 'Success', {
            closeButton: true,
          });
          $this.closeModal(true);
        },
        error(err) {
          console.log('error:', err);
          $this.toast.error(`Activity Updation Failed,Try again later`, 'Error', {
            closeButton: true,
          });
        },
      });
  }

  updateGuideEventCategoryApi(data: any) {
    let $this = this;
    this.api
      .ExecutePut(
        `${this.api?.baseUrl + api_constants.guide_event_category}/${this.activity_id
        }`,
        data
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(`Activity Updated Successfully`, 'Success', {
            closeButton: true,
          });
          $this.closeModal(true);
        },
        error(err) {
          console.log('error:', err);
          $this.toast.error(`Activity Updation Failed,Try again later`, 'Error', {
            closeButton: true,
          });
        },
      });
  }


}
